import React from "react";
import { MultiSidebarProvider } from "@/components/ui/MultiSidebar";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { NavSidebar } from "@/components/NavSidebar";
import { ReactWebChatProvider } from "@/components/ReactWebChat";
import { FilterSidebar } from "@/components/FilterSidebar";
import { OrganizationRoute } from "@/routes/OrganizationRoute";
import { BreadcrumbProvider } from "@/components/ui/Breadcrumb";
import { DialogProvider } from "@/components/DialogProvider";
import { ProtectedOutlet } from "@/components/ProtectedOutlet";
import { ScrollToTop } from "@/components/ScrollToTop";
import { FilterEnabledProvider } from "@/components/FilterEnabledProvider";

export function DashboardLayout() {
  return (
    <OrganizationRoute>
      <DialogProvider>
        <ReactWebChatProvider>
          <BreadcrumbProvider>
            <ScrollToTop />
            <FilterEnabledProvider>
              <MultiSidebarProvider
                sidebarProps={{
                  nav: {
                    keyShortcut: "b",
                  },
                  filter: {
                    keyShortcut: "g",
                    defaultOpen: false,
                    sidebarWidth: "20rem",
                  },
                }}
              >
                <NavSidebar />
                <main className="flex h-screen min-w-0 grow flex-col overflow-hidden">
                  <Breadcrumbs />
                  <div
                    className="relative grow overflow-y-scroll pb-27"
                    data-main-content
                  >
                    <ProtectedOutlet />
                  </div>
                </main>
                <FilterSidebar />
              </MultiSidebarProvider>
            </FilterEnabledProvider>
          </BreadcrumbProvider>
        </ReactWebChatProvider>
      </DialogProvider>
    </OrganizationRoute>
  );
}
